<template>
  <div id="app" :class="{ 'ppt-slide-shell': isPptSlideRoute }">
    <router-view></router-view>
  </div>
</template>

<script>
import { PPT_MODULE_CODES } from "@/constants/pptModules";

const MODE = "ppt-slide-mode";

export default {
  name: "app",
  computed: {
    isPptSlideRoute() {
      return PPT_MODULE_CODES.some(
        code => this.$route.path === `/${code}`
      );
    }
  },
  watch: {
    isPptSlideRoute: {
      immediate: true,
      handler(on) {
        this.togglePptModeClass(on);
      }
    }
  },
  mounted() {
    document.onkeydown = function() {
      var e = window.event || arguments[0];
      if (e.ctrlKey && e.keyCode == 85) {
        //禁止ctrl+u
        return false;
      }
    };
  },
  beforeDestroy() {
    this.togglePptModeClass(false);
  },
  methods: {
    togglePptModeClass(on) {
      const el = document.documentElement;
      const bd = document.body;
      if (on) {
        el.classList.add(MODE);
        bd.classList.add(MODE);
      } else {
        el.classList.remove(MODE);
        bd.classList.remove(MODE);
      }
    }
  }
};
</script>

<style lang="less"></style>
